import { IAdFoxBannerTypeParams } from '../types/adfox';

export const BANNER_TYPE_PARAMS: { [key: string]: IAdFoxBannerTypeParams } = {
  contract: {
    p1: 'bvebl',
    p2: 'fjuj',
  },
  seo: {
    p1: 'bvkkh',
    p2: 'fkhh',
    pct: 'b',
    pfb: 'a',
    pfc: 'a',
    pli: 'a',
    plp: 'a',
    pop: 'a',
    pt: 'b',
  },
  country_buildings_banner: {
    p1: 'csmfw',
    p2: 'hmvu',
  },
};
